import LegalPage from './LegalPage';

const Terms = () => {
  return <LegalPage file="agb" title="Allgemeine Geschäftsbedingungen" />;
};

export default Terms;
